export const selectUserType = (state: any) => state.getIn(['user', 'type']);
export const selectUserLocation = (state: any) => state.getIn(['user', 'distributionCenter']);
export const selectUser = (state: any) => state.get('user');
export const selectUserLocationType = (state: any) => state.getIn(['user', 'distributionCenter', 'type']);
export const selectUserRoleId = (state: any) => state.getIn(['user', 'roleId']);
